import Vue from 'vue'
import Vuex from 'vuex'
import { interpretToken } from '@/api/apis'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token'),
    checkPasswordStatus: true,
    studenInfo: JSON.parse(localStorage.getItem("studenInfo")) || null,
    tokenInfo: JSON.parse(localStorage.getItem("tokenInfo")) || null
  },
  getters: {
    getToken(state) {
      return state.token;
    },
  },
  mutations: {
    setPassword(state, status) {
      state.checkPasswordStatus = status;
    },
    setTokenInfo(state, item) {
      state.tokenInfo = item
    }
  },
  actions: {
    getTokenInfo({ commit }) {
      return new Promise((resolve, reject) => {
        interpretToken()
          .then((res) => {
            localStorage.setItem("tokenInfo", JSON.stringify(res.data));
            commit('setTokenInfo', res.data);
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          });
      })
    }
  },
  modules: {

  }
})
